export default function Footer() {
  return (
    <footer>
      <section className="newsletter-signup">
        <h2 className="gc-text">Emails are annoying.</h2>
        <p>I post updates on Telegram instead.</p>
        <a href="https://t.me/+jk3Zz8C9TLJhOGJk" className="p-btn">
          Join Channel
        </a>
      </section>
      <p>
        &copy; 2026{" "}
        <a
          style={{ color: "white", textDecoration: "none" }}
          href="https://amantes30.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          amantes30
        </a>
        . All rights reserved.
      </p>
    </footer>
  );
}
